import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const InfoIcon: React.FC<ISvgIcons> = ({ className = "", ...rest }) => (
    <svg
        viewBox="0 0 25 25"
        className={`${className}`}
        stroke="currentColor"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...rest}
    >
        <path d="M12.75 22.25C18.25 22.25 22.75 17.75 22.75 12.25C22.75 6.75 18.25 2.25 12.75 2.25C7.25 2.25 2.75 6.75 2.75 12.25C2.75 17.75 7.25 22.25 12.75 22.25Z" />
        <path d="M12.75 8.25V13.25" />
        <path d="M12.7446 16.25H12.7536" strokeWidth="2" />
    </svg>
)
